import styled from "styled-components";
import { Box, Flex, Image, Link } from "rebass/styled-components";
import CatalogItem from "../components/CatalogItem";

const ImageBox = styled(Image)`
  padding: 0;
  width: 100%;
  vertical-align: middle;
`;

const imgPath = "https://merletimages.imgix.net/";

const CatalogDynamic = ({ children, merken, type }) => {
  if (merken && merken.length > 0) {
    return (
      <Flex
        width="90%"
        maxWidth="996px"
        flexDirection="row"
        mx="auto"
        flexWrap="wrap"
      >
        <Box maxWidth="792px" pt={4} pb={3} variant="intro">
          Bekijk hieronder enkele catalogi van een greep uit het ruime aanbod
          dat Merlet te bieden heeft.
        </Box>

        {merken.map((merk, i) => {
          // if (merk.type != type) return;
          return (
            <CatalogItem key={i}>
              <ImageBox
                src={merk.data.logo.url}
                alt={merk.data.logo.alt}
                sx={{
                  position: "relative",
                  borderStyle: "solid",
                  borderWidth: "1px",
                  borderColor: "rgb(214, 185, 133, .4)",
                  "&:hover": {
                    opacity: 0,
                  },
                }}
              ></ImageBox>
              <Box
                sx={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  padding: "inherit",
                  opacity: 0,
                  "&:hover": {
                    opacity: 1,
                  },
                }}
              >
                <Link
                  href={
                    merk.data.catalogus_list.length > 0 &&
                    merk.data.catalogus_list[0].catalogus_href.url
                  }
                >
                  <ImageBox src={imgPath + "bekijk-catalogus.png"}></ImageBox>
                </Link>
              </Box>
              <Box
                py="2"
                variant="title"
                color="dark"
                sx={{ textTransform: "uppercase" }}
              >
                {merk.data.name}
              </Box>
              <Box>{merk.data.slogan}</Box>
            </CatalogItem>
          );
        })}
      </Flex>
    );
  } else {
    return null;
  }
};

export default CatalogDynamic;
